import { memo, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { UploadPreviewLoaders } from '@air/feature-uploads/ui';
import { activeUploadsSelector } from '@air/redux-uploader';

import { usePrivateUploadManager } from '~/components/Upload/hooks/usePrivateUploadManager';
import { useReloadApplication } from '~/providers/ReloadApplicationProvider';

/** Settings must run the upload pipeline without the pre-ui2026 tracking pane. */
export const PrivateUploadManagerRuntime = memo(() => {
  const activeUploads = useSelector(activeUploadsSelector);
  const { onAddPendingAction, onRemovePendingAction } = useReloadApplication();

  useEffect(() => {
    if (activeUploads.length > 0) {
      onAddPendingAction({ id: 'upload', description: 'Uploading files' });
    } else {
      onRemovePendingAction('upload');
    }
  }, [activeUploads, onAddPendingAction, onRemovePendingAction]);

  usePrivateUploadManager();

  return <UploadPreviewLoaders />;
});

PrivateUploadManagerRuntime.displayName = 'PrivateUploadManagerRuntime';
